module.exports = ("npm");


//////////////////
// WEBPACK FOOTER
// ./~/@dp/knb/~/@dp/dpapp/lib/type.js
// module id = 562
// module chunks = 0